/**
 * Default empty beneficiary model structure.
 * Used when no beneficiary exists for a user.
 */
export const EMPTY_BENEFICIARY_MODEL = {
  BeneficiaryFirstName: null,
  BeneficiaryLastName: null,
  BeneficiaryEmailAddress: null,
  BeneficiaryBankAccountName: null,
  iban: null,
};
